<template>
  <FlagProvider :unleash-client="client">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </FlagProvider>
</template>
<script setup lang="ts">
import { FlagProvider, UnleashClient } from '@unleash/proxy-client-vue';

import { useAuth } from '@/composables/models/useAuth';
import { useFirebaseStorage } from '@/composables/models/useFirebaseStorage';
import { useBaseConfirm } from '@/composables/ui/useConfirm';
import { useBaseToast } from '@/composables/ui/useToast';
import { useMockedAuth } from '@/composables/utils/useMockAuth';
import { useToastKey, useAuthKey, useRuntimeConfigKey, useRouterKey, useConfirmKey, useFetchKey, useFirebaseStorageKey, useRouteKey } from '@/injectionKeys';

const runtimeConfig = useRuntimeConfig();
const config = {
  url: runtimeConfig.public.UNLEASH_API_URL,
  clientKey: runtimeConfig.public.UNLEASH_API_TOKEN,
  refreshInterval: 15,
  appName: runtimeConfig.public.UNLEASH_API_APP_NAME,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let client: any;
try {
  client = new UnleashClient(config);
} catch (e) {
  console.error(e);
}

onMounted(() => {
  const asyncProcess = async () => {
    client && client.start();
  };
  asyncProcess();
});

provide(useToastKey, useBaseToast);
provide(useConfirmKey, useBaseConfirm);
if (runtimeConfig.public.PLAYWRIGHT_TEST === 'true') {
  provide(useAuthKey, useMockedAuth);
} else {
  provide(useAuthKey, useAuth);
}
provide(useRuntimeConfigKey, useRuntimeConfig);
provide(useRouterKey, useRouter);
provide(useRouteKey, useRoute);
provide(useFetchKey, useFetch);
provide(useFirebaseStorageKey, useFirebaseStorage);

useHead({
  meta: [
    {
      name: 'referrer',
      content: 'no-referrer-when-downgrade',
    },
  ],
});
</script>
